import BigNumber from 'bignumber.js';
import { createSelector } from 'reselect';
import config from '../../config';
import { buyValue, orderTypes } from '../../constants/sendOrder/orderEntryFormConstants';
import { getPriceForQuantity, getOrdersBySide } from '../../helpers/orderHelper';
import { getPegPriceByType } from '../../helpers/placeOrderHelper';
export var orderTotalSelector = createSelector([function (state) {
  return state.apexCore.level1;
}, function (state) {
  return state.apexCore.level2;
}, function (state, options) {
  return options.form;
}], function (level1, level2, form) {
  var orderType = form.orderType,
    quantity = form.quantity,
    side = form.side,
    stopPrice = form.stopPrice,
    limitPrice = form.limitPrice,
    trailingAmount = form.trailingAmount,
    limitOffset = form.limitOffset;
  if (orderType === orderTypes.market.displayName) {
    var _config$OrderCalcBuff = config.OrderCalcBuffer;
    _config$OrderCalcBuff = _config$OrderCalcBuff === undefined ? {} : _config$OrderCalcBuff;
    var priceBuffer = _config$OrderCalcBuff.priceBuffer;
    var orders = getOrdersBySide(side, level2);
    var _price = getPriceForQuantity(quantity, priceBuffer, orders, true, side);
    return _price.Price;
  }
  if (orderType === orderTypes.stopMarket.displayName) {
    var _price2 = new BigNumber(stopPrice);
    var _parsedQuantity = new BigNumber(quantity);
    return _price2.times(_parsedQuantity);
  }
  if (orderType === orderTypes.stopLimit.displayName) {
    var _price3 = new BigNumber(limitPrice);
    var _parsedQuantity2 = new BigNumber(quantity);
    return _price3.times(_parsedQuantity2);
  }
  if (orderType === orderTypes.trailingStopMarket.displayName) {
    var pegPrice = new BigNumber(getPegPriceByType(level1, form));
    var _price4 = side === buyValue ? pegPrice.plus(trailingAmount) : pegPrice.minus(trailingAmount);
    var _parsedQuantity3 = new BigNumber(quantity);
    return _price4.times(_parsedQuantity3);
  }
  if (orderType === orderTypes.trailingStopLimit.displayName) {
    var _pegPrice = new BigNumber(getPegPriceByType(level1, form));
    var _price5 = side === buyValue ? _pegPrice.plus(trailingAmount).plus(limitOffset) : _pegPrice.minus(trailingAmount).minus(limitOffset);
    var _parsedQuantity4 = new BigNumber(quantity);
    return _price5.times(_parsedQuantity4);
  }
  if (orderType === orderTypes.reportBlockTrade.displayName) {
    var _price6 = new BigNumber(form.price || '0');
    var _parsedQuantity5 = new BigNumber(quantity);
    if (form.useNewForm) {
      return _parsedQuantity5 * _price6;
    }
    return side === buyValue ? _price6 : _parsedQuantity5;
  }

  // Default:
  var price = new BigNumber(limitPrice);
  var parsedQuantity = new BigNumber(quantity);
  return price.times(parsedQuantity);
});